// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth} from "firebase/auth"
import { GoogleAuthProvider } from "firebase/auth";
import {getFirestore} from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDXE1OG5VeMAgWtmiLYLGG9uHPGZc_zNYk",
  authDomain: "chatapp-2d53d.firebaseapp.com",
  projectId: "chatapp-2d53d",
  storageBucket: "chatapp-2d53d.appspot.com",
  messagingSenderId: "291170466855",
  appId: "1:291170466855:web:4af64230a85f7f266ca202"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const Auth = getAuth(app);
const Provider = new GoogleAuthProvider();
const db = getFirestore(app);

export {Auth, Provider, db};
